module.exports = __webpack_public_path__ + "static/media/sort-ascending.70adde42.svg";